__turbopack_context__.v({
  "header": "top-panel-module-scss-module__AvHjdq__header",
  "headerWrapper": "top-panel-module-scss-module__AvHjdq__headerWrapper",
  "root": "top-panel-module-scss-module__AvHjdq__root",
  "title": "top-panel-module-scss-module__AvHjdq__title",
  "types": "top-panel-module-scss-module__AvHjdq__types",
});
